if (typeof window.mapLocations !== 'undefined') {
    const map = document.querySelector('.is-style-map');
    map.classList.add('no-active');
    if (map) {
        window.mapLocations.forEach(location => {
            const marker = document.createElement('div');
            marker.innerHTML = '<svg width="17" height="20" viewBox="0 0 17 20" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round" stroke="currentColor" stroke-width="2"><path d="M16 8.364C16 14.09 8.5 19 8.5 19S1 14.09 1 8.364c0-1.953.79-3.826 2.197-5.207A7.571 7.571 0 0 1 8.5 1c1.99 0 3.897.776 5.303 2.157A7.296 7.296 0 0 1 16 8.364Z" fill="#D8DDD9"/><path d="M8.5 10.818c1.38 0 2.5-1.099 2.5-2.454 0-1.356-1.12-2.455-2.5-2.455S6 7.008 6 8.364c0 1.355 1.12 2.454 2.5 2.454h0Z"/></g></svg>'
            marker.id = 'marker-' + location.id;
            marker.style.top = location.y + '%';
            marker.style.left = location.x + '%';

            map.append(marker);
        });
    }
}
